import React, { useEffect, useState , useRef} from 'react';
import Select from 'react-select';
import axios from 'axios';
import { useUser } from "../context/UserContext";
import './WalkInEnrollment.css';
import Swal from 'sweetalert2';
import { hasPrivilege } from '../utils/hasPrivilege';
const WalkInEnrollment = () => {
  const [academies, setAcademies] = useState([]);
  const { selectedCenter, userData } = useUser();
  const userId = userData?.userId;
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [sportsOptions, setSportsOptions] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [verified, setVerified] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedPersonId, setSelectedPersonId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [newUserName, setNewUserName] = useState('');
  const [joiningDate, setJoiningDate] = useState(getTodayDate());
  const [batchDetails, setBatchDetails] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [playerLevels, setPlayerLevels] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showSummaryPanel, setShowSummaryPanel] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [couponOptions, setCouponOptions] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [manualCouponCode, setManualCouponCode] = useState('');
  const [showCouponSection, setShowCouponSection] = useState(false);
  const [isExistingUser, setIsExistingUser] = useState(null);
  const [newUserGender, setNewUserGender] = useState('');
  const [discountGivenBy, setDiscountGivenBy] = useState(null);
  const [discountedAmount, setDiscountedAmount] = useState(0);
  const [discountComment, setDiscountComment] = useState('');
  const [batchSummary, setBatchSummary] = useState(null);


  const handleFetchCoupons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_COUPON_COACHING}?academyId=${selectedAcademy?.value}&scope=COACHING_SUBSCRIPTION&sportId=${selectedSport?.value}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-authorization': authToken,
          }
        }
      );
      if (response.data.success) {
        const formattedCoupons = response.data.data.coupons.map(coupon => ({
          label: `${coupon.title} - ${coupon.couponCode}`,
          value: coupon.couponCode,
          ...coupon
        }));
        setCouponOptions(formattedCoupons);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      Swal.fire('Error', 'Failed to fetch coupons.', 'error');
    }
  };

  const handleApplyNow = async () => {
    const codeToApply = manualCouponCode || selectedCoupon?.couponCode;

    if (!codeToApply) {
      Swal.fire('No Coupon', 'Please enter or select a coupon code.', 'warning');
      return;
    }

    if (!selectedPlan || !selectedPlan.planFees) {
      Swal.fire('Select Plan', 'Please select a plan before applying the coupon.', 'warning');
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_VALIDATE_COUPON}?academyId=${selectedAcademy?.value}&scope=COACHING_SUBSCRIPTION&code=${codeToApply}&orderAmount=${selectedPlan.paybleAmount}&sportId=${selectedSport?.value}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-authorization': authToken,
          }
        }
      );

      if (response.data.success) {
        const discountPercentage = response.data.data.coupon.percentage;
        const maxDiscount = response.data.data.coupon.maxDiscountAmount;

        const rawDiscount = (selectedPlan.paybleAmount * discountPercentage) / 100;
        const formattedDiscount = parseFloat(rawDiscount.toFixed(2));
        const discountAmount = Math.min(formattedDiscount, maxDiscount);

        const newPlan = {
          ...selectedPlan,
          discountedFees: selectedPlan.paybleAmount - discountAmount,
          discountAmount,
        };

        setSelectedPlan(newPlan);
        Swal.fire({
          icon: 'success',
          title: '🎉 Hurray!',
          text: `You got a discount of ₹${discountAmount}`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire('Invalid', 'Coupon is not valid.', 'error');
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      Swal.fire('Error', 'Something went wrong while applying the coupon.', 'error');
    }
  };

  const formatDay = (day) => {
    const map = {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun'
    };
    return map[day.toLowerCase()] || day;
  };

  useEffect(() => {
    const fetchPlayerLevels = async () => {
      if (selectedAcademy && selectedSport) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_SLOT_COACHING}?sport_id=${selectedSport.value}&academy_id=${selectedAcademy.value}`,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-authorization': authToken,
              }
            }
          );
          if (response.data.success) {
            setPlayerLevels(response.data.data.playerLevel);
            setBatchDetails(response.data.data.batch_details);
          }
        } catch (error) {
          console.error("Error fetching player levels:", error);
        }
      } else {
        setPlayerLevels([]);
      }
    };

    fetchPlayerLevels();
  }, [selectedAcademy, selectedSport, selectedLevel]);

  const getUniqueBatches = (batches) => {
    const seen = new Set();
    return batches.filter(batch => {
      const daysKey = Object.values(batch.weekDetails).sort().join(',');
      const uniqueKey = `${batch.displayTime}_${daysKey}`;
      if (seen.has(uniqueKey)) return false;
      seen.add(uniqueKey);
      return true;
    });
  };

  const handleLevelSelect = (level) => {
    setSelectedLevel(level);
    setSelectedBatch(null);
    setSelectedPlan(null);

    const matchedBatches = batchDetails.filter(
      (batch) =>
        batch.proficiency === level.name &&
        batch.batchType === (selectedCategory === 'Kid' ? 'KIDS' : 'ADULTS')
    );

    setFilteredBatches(matchedBatches);
  };

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const API_ENDPOINT_SEND_OTP = process.env.REACT_APP_API_URL_OTP_SEND;

  const handleSendOTP = async () => {
    if (mobileNumber.length === 10) {
      const payload = {
        data: {
          phone_number: `+91${mobileNumber}`,
        },
      };

      try {
        const res = await axios.post(API_ENDPOINT_SEND_OTP, payload, {
          headers: {
            'Content-Type': 'application/json',
            'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
          },
        });

        if (res.status === 200) {

          const isExisting = res.data?.data?.is_existing_user;
          setIsExistingUser(isExisting);

          setOtpSent(true);
          setUserDetails(null); 

          Swal.fire({
            icon: 'success',
            title: 'OTP Sent!',
            text: 'OTP has been sent to your mobile number.',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed to Send OTP',
            text: 'Unexpected response from server. Please try again.',
          });
        }

      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Network Error',
          text: 'Could not connect to server. Please try again.',
        });
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Number',
        text: 'Enter a valid 10-digit mobile number.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  const [authToken, setAuthToken] = useState(null);

  const handleVerifyOTP = async () => {
    if (otp.length === 6) {
      const payload = {
        data: {
          phone_number: `+91${mobileNumber}`,
          firebase_token: "",
          device_type: "",
          app_version: "",
          fcm_token: "",
          ONE_SIGNAL_USERID: "",
          one_signal_device_id: "",
          has_firebase_check: false,
          login_type: "WEB",
          otp: otp,
        },
      };

      try {
        const res = await axios.post(
          process.env.REACT_APP_API_URL_OTP_VERIFY,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (res.data.success) {

          const newToken = res.headers['x-authorization'];
          if (newToken) {
            setAuthToken(newToken);
          }

          const responseData = res.data.data;

          if (isExistingUser === false) {
            setUserDetails({
              parent: {
                id: responseData.user.id,
                name: '', 
                gender: '', 
              },
              children: [],
            });
            setNewUserName('');
            setNewUserGender('');
          } else {
            const parentUser = {
              id: responseData.user.id,
              name: responseData.user.name,
              gender: responseData.user.genderType || 'MALE',
            };

            const childUsers = (responseData.check_in_users || []).slice(1).map((child) => ({
              id: child.id,
              name: child.name,
              gender: child.genderType || 'MALE',
            }));

            setUserDetails({
              parent: parentUser,
              children: childUsers,
            });
            setSelectedPersonId(parentUser.id);
          }

          setVerified(true);
        } else {
          Swal.fire('Verification Failed', res.data.message || 'Invalid OTP', 'error');
        }

      } catch (error) {
        console.error("OTP Verification Error:", error);
        Swal.fire('Verification Failed', '', 'error');
      }
    }
  };

  useEffect(() => {
    const fetchAcademies = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL_ACADEMIES, {
          headers: {
            'Content-Type': 'application/json',
            'x-authorization': authToken,
          }
        });

        let academyList = response.data.data.academies || [];


        if (userData?.userType === 'ACADEMY' && Array.isArray(userData.academyIds)) {
          academyList = academyList.filter(academy =>
            userData.academyIds.includes(academy.id)
          );
        }

        setAcademies(academyList);

        if (selectedCenter) {
          const defaultAcademy = academyList.find(a => a.id === Number(selectedCenter));
          if (defaultAcademy) {
            const selectedOption = {
              label: defaultAcademy.name,
              value: defaultAcademy.id,
              offering: defaultAcademy.offering
            };

            setSelectedAcademy(selectedOption);


            const sports = (defaultAcademy.sports || []).map((sport) => ({
              label: sport.name,
              value: sport.sport_id,
              image: sport.sport_pic
            }));
            setSportsOptions(sports);
          }
        }
      } catch (error) {
        console.error('Error fetching academies:', error);
      }
    };

    fetchAcademies();
  }, [authToken, selectedCenter, userData]);


  const handleAcademyChange = (selectedOption) => {
    setSelectedAcademy(selectedOption);
    setSelectedSport(null);
    setSelectedLevel(null);
    setSelectedBatch(null);
    setSelectedPlan(null);
    setFilteredBatches([]);
    setShowCouponSection(false);
    setCouponOptions([]);
    setSelectedCoupon(null);
    setManualCouponCode('');

    const selected = academies.find(a => a.id === selectedOption.value);
    if (selected && selected.sports) {
      const sports = selected.sports.map((sport) => ({
        label: sport.name,
        value: sport.sport_id,
        image: sport.sport_pic
      }));
      setSportsOptions(sports);
    } else {
      setSportsOptions([]);
    }
  };


  const handleSportChange = (selectedOption) => {
    setSelectedSport(selectedOption);
    setSelectedLevel(null);
    setSelectedBatch(null);
    setSelectedPlan(null);
    setFilteredBatches([]);
    setShowCouponSection(false);
    setCouponOptions([]);
    setSelectedCoupon(null);
    setManualCouponCode('');
  };


  const academyOptions = academies.map((academy) => ({
    label: academy.name,
    value: academy.id,
    offering: academy.offering
  }));

  const handleJoiningDateChange = (e) => {
    setJoiningDate(e.target.value);
  };
  const shouldSendPlayerNameRef = useRef(false);

  const [isKidAndNewAtStart, setIsKidAndNewAtStart] = useState(false);

  useEffect(() => {
    if (selectedCategory === 'Kid' && selectedPersonId === 'new') {
      shouldSendPlayerNameRef.current = true;
    }

  }, [selectedCategory, selectedPersonId]);
  
  const buildSelectCoachingPayload = () => {
    if (!selectedPlan) return null;

    let payloadData = {
      plan_id: selectedPlan.id,
      join_date: joiningDate,
      coupon_code: selectedCoupon?.couponCode || null,
      discount: discountedAmount,
      discount_given_by: discountGivenBy?.value || null,
      discount_comment: discountComment || null,
       login_user: userId,
    };

    if (selectedPersonId === 'new') {
      payloadData.user_id = userDetails?.parent?.id;
      payloadData.parent_user_id = userDetails?.parent?.id;
      payloadData.player_name = newUserName;
      payloadData.parent_name = userDetails?.parent?.name || '';
      payloadData.gender = newUserGender;
    } else {
      payloadData.user_id = selectedPersonId;
    }
    const shouldSendPlayerDetails =
    selectedCategory === 'Kid' &&
    ((selectedPersonId === 'new') || shouldSendPlayerNameRef.current || isExistingUser === false);

  if (shouldSendPlayerDetails) {
    payloadData.parent_name = userDetails?.parent?.name || newUserName || '';
    payloadData.player_name = newUserName || userDetails?.parent?.name || '';
  }

    return { data: payloadData };
  };

  const handleSubmit = async () => {
    if (!selectedPlan || (!userDetails?.parent?.id && isExistingUser !== false)) {
      Swal.fire('Missing Info', 'Please select a plan and user before submitting.', 'warning');
      return;
    }
    await fetchBatchSummary();
    try {
      if (isExistingUser === false) {
        if (!newUserName || !newUserGender) {
          Swal.fire('Missing Info', 'Please enter parent name and gender.', 'warning');
          return;
        }

        const createUserPayload = {
          data: {
            id: userDetails.parent.id,
            name: newUserName,
            genderType: newUserGender,
          },
        };

        const createUserResponse = await axios.post(
          process.env.REACT_APP_API_CREATE_USER,
          createUserPayload,
          { headers: { 'x-authorization': authToken } }
        );

        if (!createUserResponse.data.success) {
          Swal.fire('Error', 'Failed to create parent.', 'error');
          return;
        }

        const updatedUserDetails = {
          ...userDetails,
          parent: { ...userDetails.parent, name: newUserName, gender: newUserGender }
        };
        setUserDetails(updatedUserDetails);
        setSelectedPersonId(userDetails.parent.id);


        const payload = {
          data: {
            plan_id: selectedPlan.id,
            join_date: joiningDate,
            coupon_code: selectedCoupon?.couponCode || null,
            user_id: updatedUserDetails.parent.id,
            parent_user_id: updatedUserDetails.parent.id,
            player_name: newUserName,
            parent_name: newUserName,
            gender: newUserGender,
            discount: discountedAmount,
            discount_given_by: discountGivenBy?.value || null,
            discount_comment: discountComment || null,
             login_user: userId,
          }
        };

        return await finalizeEnrollment(payload);
      }

      const payload = buildSelectCoachingPayload();
      return await finalizeEnrollment(payload);

    } catch (error) {
      console.error(' Submission Error:', error);
      Swal.fire({
        icon: 'error',
        title: ' Error',
        text: error.response?.data?.error_message || 'Something went wrong during submission.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  const calculateEndDate = (startDateStr, termId) => {
    const startDate = new Date(startDateStr);
    let monthsToAdd = 0;
    switch (termId) {
      case 1:
        monthsToAdd = 1;
        break;
      case 2:
        monthsToAdd = 3;
        break;
      case 3:
        monthsToAdd = 12;

        break;
      case 4:
        monthsToAdd = 6;
        break;
      default:
        monthsToAdd = 0;
    }
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + monthsToAdd);
    endDate.setDate(0); 
    return endDate;
  };

  const formatDateToPlanStyle = (date) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    const year = `'${date.getFullYear().toString().slice(-2)}`;
    return `${day} ${month} ${year}`;
  };
  const finalizeEnrollment = async (payload) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_SELECT_COACHCING}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-authorization': authToken,
        }
      }
    );
    if (response.data.success) {
      const { amount, joiningFees, order_id } = response.data.data;

      const updatedPlan = {
        ...selectedPlan,
        amount,
        joiningFees,
        order_id
      };

      setSelectedPlan(updatedPlan);
      setShowSummaryPanel(true);

    } else {
      Swal.fire({
        icon: 'error',
        title: '❌ Oops!',
        text: response.data.message || 'Submission failed.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };




  const resetForm = () => {
    setSelectedAcademy(null);
    setSelectedSport(null);
    setMobileNumber('');
    setOtpSent(false);
    setOtp('');
    setVerified(false);
    setUserDetails(null);
    setSelectedPersonId(null);
    setSelectedCategory(null);
    setNewUserName('');
    setJoiningDate(getTodayDate());
    setBatchDetails([]);
    setSelectedLevel(null);
    setPlayerLevels([]);
    setFilteredBatches([]);
    setSelectedBatch(null);
    setSelectedPlan(null);
    setShowSummaryPanel(false);
    setSelectedPaymentMethod('');
    setCouponOptions([]);
    setSelectedCoupon(null);
    setManualCouponCode('');
    setShowCouponSection(false);
    setIsKidAndNewAtStart(false);
    shouldSendPlayerNameRef.current = false;
  };
  const handleVenueQRPayment = async () => {
    const userId = getUserId();
    if (!userId) {
      return showToast({ icon:'error', title:'Missing Info', text:'User ID not found.' });
    }
  
    showLoading('Processing Payment...');
    try {
      const payload = buildSelectCoachingPayload();
      const enrollRes = await axios.post(
        process.env.REACT_APP_API_SELECT_COACHCING,
        payload,
        { headers: { 'x-authorization': authToken } }
      );
      const { success, data: enrollData, message: enrollMsg } = enrollRes.data;
      if (!success) {
        throw new Error(`select_coaching failed: ${enrollMsg}`);
      }

      const { order_id } = enrollData;
      const totalPayable = computeTotalPayable();
      const { data: baseData } = buildSelectCoachingPayload()
      const confirmPayload = {
        data: {
          due_order_id:   order_id,
          amount: selectedPlan?.amount,
          payment_details:{ razorpay_payment_id: '' },
          is_walk_in:     true,
          payment_method: 'UPI',
          login_user: userId,

        },
      };

      const confirmRes = await axios.post(
        process.env.REACT_APP_API_CASH_QR,
        confirmPayload,
        { headers: { 'x-authorization': authToken } }
      );
  
      Swal.close();
  
      if (confirmRes.data.code === 200) {
        showToast({ icon:'success', title:'✅ Payment Success', text:'Enrolled!' });
        resetForm();
      } else {
        throw new Error(`cash-qr failed: ${confirmRes.data.message}`);
      }
  
    } catch (err) {
      Swal.close();
      console.error(' Venue QR Payment Error —', {
        message: err.message,
        serverResponse: err.response?.data,
        status: err.response?.status
      });
      const userMsg = err.response?.data?.error_message
        || err.message
        || 'Something went wrong.';
      showToast({ icon:'error', title:' Error', text: userMsg });
    }
  };
  

  

  const computeTotalPayable = () => {
    if (selectedPlan?.amount) {
      return selectedPlan.amount;
    }
  
    const planAmt = selectedPlanSummary?.paybleAmount ?? 0;
    const coupon = selectedPlan?.discountAmount || 0;
    const manual = discountedAmount || 0;
    const regFee = selectedPlan?.joiningFees || 0;
  
    return planAmt - coupon - manual + regFee;
  };
  


const handleCashPayment = async () => {
  const userId = getUserId();
  if (!userId) {
    return showToast({ icon:'error', title:'Missing Info', text:'User ID not found.' });
  }

  showLoading('Processing Payment...');
  try {
    const payload = buildSelectCoachingPayload();
    const enrollRes = await axios.post(
      process.env.REACT_APP_API_SELECT_COACHCING,
      payload,
      { headers: { 'x-authorization': authToken } }
    );
    const { success, data: enrollData, message: enrollMsg } = enrollRes.data;
    if (!success) {
      throw new Error(`select_coaching failed: ${enrollMsg}`);
    }


    const { order_id } = enrollData;

    const totalPayable = computeTotalPayable();
    const { data: baseData } = buildSelectCoachingPayload();
    const confirmPayload = {
      data: {
        due_order_id:   order_id,
        amount: selectedPlan?.amount,
        payment_details:{ razorpay_payment_id: '' },
        is_walk_in:     true,
        payment_method: "CASH",
        login_user: userId,
      },
    };

    const confirmRes = await axios.post(
      process.env.REACT_APP_API_CASH_QR,
      confirmPayload,
      { headers: { 'x-authorization': authToken } }
    );


    Swal.close();

    if (confirmRes.data.code === 200) {
      showToast({ icon:'success', title:'✅ Payment Success', text:'Enrolled!' });
      resetForm();
    } else {
      throw new Error(`cash-qr failed: ${confirmRes.data.message}`);
    }

  } catch (err) {
    Swal.close();
    console.error(' Venue QR Payment Error —', {
      message: err.message,
      serverResponse: err.response?.data,
      status: err.response?.status
    });
    const userMsg = err.response?.data?.error_message
      || err.message
      || 'Something went wrong.';
    showToast({ icon:'error', title:' Error', text: userMsg });
  }
};
  


  const getUserId = () => {
    if (isExistingUser === false) {
      return userDetails?.parent?.id;
    } else if (selectedPersonId === 'new') {
      return userDetails?.parent?.id;
    } else if (selectedPersonId) {
      return selectedPersonId;
    } else if (userDetails?.parent?.id) {
      return userDetails.parent.id;
    }
    return null;
  };


  const showLoading = (message = 'Processing...') => {
    Swal.fire({
      title: message,
      html: 'Please wait...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  };

  const showToast = ({ icon, title, text }) => {
    Swal.fire({
      icon,
      title,
      text,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
    });
  };

  const handleRPQRPayment = async () => {
    const userId = getUserId();
    if (!userId) {
      Swal.fire({
        icon: 'error',
        title: '❌ Missing Info',
        text: 'User ID not found. Cannot proceed.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    showLoading('Processing Payment...');

    try {
      const payload = buildSelectCoachingPayload();
      const response = await axios.post(
        process.env.REACT_APP_API_SELECT_COACHCING,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-authorization': authToken,
          },
        }
      );
      if (!response.data.success) {
        Swal.fire({
          icon: 'error',
          title: '❌ Oops!',
          text: response.data.message || 'Failed to initiate payment.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        Swal.close();
        return;
      }
  
      const newAuthToken = response.headers['x-authorization'];
      const { order_id, amount, joiningFees } = response.data.data;
      const razorAmount = Math.round(
        ((selectedPlan?.amount ?? 0) + (selectedPlan?.joiningFees ?? 0)) * 100
      );
  
      const playerName  = newUserName || userDetails?.parent?.name || 'Player';
      const phone       = mobileNumber.length === 10 ? `+91${mobileNumber}` : 'N/A';
      const displayTime = selectedBatch.displayTime;
      const daysList    = Object.values(selectedBatch.weekDetails).map(formatDay).join(', ');
      const hasBatchName = Boolean(selectedBatch.batch_name);
      const batchInfo = hasBatchName
        ? `Display Time: ${displayTime} Batch Name: ${selectedBatch.batch_name}`
        : `Batch ID: ${selectedBatch.batch_id}, Time: ${displayTime}, Days: ${daysList}`;
      const planType = (() => {
        switch (selectedPlan.term_id) {
          case 1: return 'Monthly';
          case 2: return 'Quarterly';
          case 4: return 'Yearly';
          default: return 'Yearly';
        }
      })();
      const optionDescription = 
        `Walkin: Coaching Plan for ${playerName}, ` +
        `Ph no: ${mobileNumber}, ` +
        `${batchInfo}, ` +
        `Plan Type: ${planType}, ` +
        `Order Id: ${order_id}`;
        const { data: baseData } = buildSelectCoachingPayload();
      const options = {
        key: process.env.REACT_APP_API_RAZORPAY_KEY,
        currency: 'INR',
        amount: razorAmount.toString(),
        name: 'Machaxi',
        login_user: userId,
        description: optionDescription,
        image: '/images/header-logo.png',
        handler: async (razorpayResponse) => {
          const razorpay_payment_id = razorpayResponse.razorpay_payment_id;
          if (!razorpay_payment_id) return;
  
          showLoading('Confirming Payment...');
  
          try {
            const confirmPayload = {
              data: {
                due_order_id: order_id,
                amount: selectedPlan?.amount,
                payment_details: { razorpay_payment_id },
                is_walk_in: true,
                login_user: userId,
                ...(selectedCategory === 'Kid' && selectedPersonId === 'new'
                ? { player_name: baseData.player_name }
                : {}
              ),
              },
            };

            const confirmRes = await axios.post(
              process.env.REACT_APP_API_RAZOR_COACHING,
              confirmPayload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'x-authorization': newAuthToken || authToken,
                },
              }
            );
            Swal.close();
            if (confirmRes.data.code === 200) {
              Swal.fire({
                icon: 'success',
                title: '✅ Payment Success',
                text: 'Player has been enrolled successfully',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });
              resetForm();
              window.scrollTo(0, 0);
            } else {
              Swal.fire({
                icon: 'error',
                title: '⚠️ Payment Error',
                text: confirmRes.data.message || 'Could not confirm payment.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });
            }
          } catch (err) {
            Swal.close();
            console.error('Payment Confirmation Error:', err);
            Swal.fire({
              icon: 'error',
              title: '❌ Payment Failed',
              text: err.response?.data?.error_message || 'Error confirming payment.',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });
          }
        },
        prefill: {
          name: playerName,
          contact: phone,
        },
        theme: { color: '#528FF0' },
        modal: {
          ondismiss: () => {
            Swal.close();
            Swal.fire({
              icon: 'info',
              title: 'Payment Incomplete',
              text: 'You closed the payment without completing it. Please try again.',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });
          },
        },
      };
  
      Swal.close();
      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      Swal.close();
      console.error('RP QR Payment Error:', err);
      Swal.fire({
        icon: 'error',
        title: '❌ Payment Error',
        text: err.response?.data?.error_message || err.message || 'Something went wrong.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  
  
  

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setSelectedLevel(null);
    setSelectedBatch(null);
    setSelectedPlan(null);
    setFilteredBatches([]);
    setShowCouponSection(false);
    setCouponOptions([]);
    setSelectedCoupon(null);
    setManualCouponCode('');
    setSelectedSport(null);
  };
  function formatToPlanStyle(dateStr) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = months[dateObj.getMonth()];
    const year = `'${dateObj.getFullYear().toString().slice(-2)}`;
    return `${day} ${month} ${year}`;
  }


  function formatDate(dateObj) {
    const options = { day: '2-digit', month: 'short', year: '2-digit' };
    return dateObj.toLocaleDateString('en-GB', options).replace(',', '');
  }

  const fetchBatchSummary = async () => {
    if (!selectedBatch) return;
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_URL_FETCH_BATCH_SUMMARY}/${selectedBatch.batch_id}/`,
        { params: { join_date: joiningDate } }
      );
      const payable = resp.data.plans[0].payable_amount;
      setBatchSummary(payable);
      setShowSummaryPanel(true);
    } catch (err) {
      console.error("✖️ couldn't fetch batch summary:", err);
      Swal.fire('Error', 'Failed to load summary.', 'error');
    }
  };

  const selectedPlanSummary = batchSummary
    ? batchSummary.find(p => p.term_id === selectedPlan?.term_id)
    : null;

const getDisplayName = () => {
  if (selectedPersonId === 'new') {
    return newUserName || 'N/A';
  }

  const child = userDetails?.children?.find(c => c.id === selectedPersonId);
  if (child) {
    return child.name;
  }

  return userDetails?.parent?.name || 'N/A';
};

  return (
    <div>
      <div className="mobile-verification-box">
        <div className="floating-select-form" style={{ width: '98%' }}>
          <input
            type="tel"
            name="phone"
            className={`walkin-form ${mobileNumber ? "has-value" : ""}`}
            value={mobileNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/, '');
              setMobileNumber(value);
              setOtpSent(false);
              setVerified(false);
              setOtp('');
              setUserDetails(null);
            }}
            placeholder="Enter Phone Number"
            maxLength={10}
          />
          {mobileNumber && <label htmlFor="phone">Phone</label>}
        </div>

        {!verified && !otpSent && (
          <button type='button' className='otp-button' onClick={handleSendOTP}>Send OTP</button>
        )}
      </div>

      {otpSent && !verified && (
        <div className="otp-input-section">
          <div className="floating-select-form" style={{ width: '98%' }}>
            <input
              type="text"
              name="otp"
              className={`walkin-form ${otp ? "has-value" : ""}`}
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/, ''))}
              maxLength={6}
            />
            {otp && <label htmlFor="otp">OTP</label>}
          </div>

          <button type='button' onClick={handleVerifyOTP} className='otp-button'>
            Verify OTP
          </button>
        </div>
      )}
      {verified && (
        <div className="user-details-section">
          {isExistingUser === false ? (
            <>
              <div className="floating-select-form" style={{ width: '98%' }}>
                <input
                  type="text"
                  name="name"
                  className={`walkin-form ${newUserName ? "has-value" : ""}`}
                  value={newUserName}
                  onChange={(e) => setNewUserName(e.target.value)}
                  placeholder="Enter name"
                />
                {newUserName && <label htmlFor="name">Name</label>}
              </div>

              <div>
                <label>Select Gender:</label>
                <div className="sport-cards-container">
                  {['MALE', 'FEMALE'].map((gender) => (
                    <div
                      key={gender}
                      className={`sport-card ${newUserGender === gender ? 'selected' : ''}`}
                      onClick={() => setNewUserGender(gender)}
                    >
                      {gender}
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            userDetails && (
              <>
                <label>Select User:</label>
                <div className="sport-cards-container">
                  {/* Parent */}
                  <div
                    className={`sport-card parent-card ${selectedPersonId === userDetails.parent?.id ? 'selected' : ''}`}
                    onClick={() => {
                      setSelectedPersonId(userDetails.parent?.id);
                      setNewUserName('');
                      setNewUserGender('');
                    }}
                  >
                    👤 {userDetails.parent?.name || "Not Provided"}
                  </div>

                  {/* Children */}
                  {userDetails.children?.map((child) => (
                    <div
                      key={child.id}
                      className={`sport-card ${selectedPersonId === child.id ? 'selected' : ''}`}
                      onClick={() => {
                        setSelectedPersonId(child.id);
                        setNewUserName('');
                        setNewUserGender('');
                      }}
                    >
                      🧒 {child.name}
                    </div>
                  ))}

                  {/* Add New Player */}
                  <div
                    className={`sport-card add-player-card ${selectedPersonId === 'new' ? 'selected' : ''}`}
                    onClick={() => {
                      setSelectedPersonId('new');
                      setNewUserName('');
                      setNewUserGender('');
                    }}
                    style={{ background: '#d7f9d7', fontWeight: 'bold' }}
                  >
                    ➕ Add New Player
                  </div>
                </div>

                {/* Only if Add New Player Selected */}
                {selectedPersonId === 'new' && (
                  <>
                    <div className="floating-select-form" style={{ width: '98%', marginTop: '10px' }}>
                      <input
                        type="text"
                        name="name"
                        className={`walkin-form ${newUserName ? "has-value" : ""}`}
                        value={newUserName}
                        onChange={(e) => setNewUserName(e.target.value)}
                        placeholder="Enter new player name"
                      />
                      {newUserName && <label htmlFor="name">Player Name</label>}
                    </div>

                    <div>
                      <label>Select Gender:</label>
                      <div className="sport-cards-container">
                        {['MALE', 'FEMALE'].map((gender) => (
                          <div
                            key={gender}
                            className={`sport-card ${newUserGender === gender ? 'selected' : ''}`}
                            onClick={() => setNewUserGender(gender)}
                          >
                            {gender}
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </>
            )
          )}
        </div>
      )}




      {/* Category Selection Section */}
      {(isExistingUser === false || selectedPersonId) && (
        <div className="category-selection-section" style={{ marginTop: '1%' }}>
          <label>Select Category:</label>
          <div className="sport-cards-container">
            <div
              className={`sport-card ${selectedCategory === 'Adult' ? 'selected' : ''}`}
              onClick={() => handleCategoryChange('Adult')}
            >
              🧔 Adult
            </div>
            <div
              className={`sport-card ${selectedCategory === 'Kid' ? 'selected' : ''}`}
              onClick={() => handleCategoryChange('Kid')}
            >
              🧒 Kid
            </div>
          </div>
        </div>
      )}

      {/* Academy and Sport Selection */}
      <div className="floating-select-form" style={{ width: '100%' }}>
        <Select
          name="academy"
          options={academyOptions}
          value={selectedAcademy}
          onChange={handleAcademyChange}
          placeholder="Choose an academy"
          className={`walkin-form-dropdown ${selectedAcademy ? "has-value" : ""}`}
          classNamePrefix="walkin-select"
          styles={{
            control: (provided) => ({
              ...provided,
              padding: '5px',
            }),
            placeholder: (provided) => ({
              ...provided,
              color: 'black',
            }),
          }}
        />
      </div>

      {selectedAcademy && (
        <div>
          <label>Sport:</label>
          <div className="sport-cards-container">
            {sportsOptions.map((sport) => (
              <div
                key={sport.value}
                className={`sport-card ${selectedSport?.value === sport.value ? 'selected' : ''}`}
                onClick={() => handleSportChange(sport)}
              >
                <img
                  src={sport.image}
                  alt={sport.label}
                  style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                />
                <div className="sport-name">{sport.label}</div>
              </div>
            ))}

          </div>
        </div>
      )}
      {playerLevels.length > 0 && (
        <div style={{ marginTop: '1%', marginBottom: '1%' }}>
          <label>Select Player Level:</label>
          <div className="sport-cards-container">
            {playerLevels
              .filter((level) => {
                if (level.name === 'ADVANCED') {
                  const isAdvanceAllowed = batchDetails.some(
                    (batch) => batch.proficiency === 'ADVANCED' && batch.is_allowed === true
                  );
                  return isAdvanceAllowed;
                }
                return true;
              })
              .map((level) => (
                <div
                  key={level.name}
                  className={`sport-card ${selectedLevel?.name === level.name ? 'selected' : ''}`}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                  onClick={() => handleLevelSelect(level)}
                >
                  <img src={level.url} alt={level.displayText} style={{ width: '30px', height: '30px' }} />
                  <span>{level.displayText}</span>
                </div>
              ))}

          </div>
        </div>
      )}
      {selectedLevel && (
        <div className="batch-selection-section">
          <label>Select a Batch Time:</label>
          {filteredBatches.length === 0 ? (
            <div style={{ marginTop: '10px', fontStyle: 'italic', color: '#999' }}>
              ❌ No batch available.
            </div>
          ) : (
            <div className="sport-cards-container">
              {getUniqueBatches(filteredBatches).map((batch, idx) => (
                <div
                  key={idx}
                  className={`sport-card ${selectedBatch?.batch_id === batch.batch_id ? 'selected' : ''}`}
                  onClick={() => {
                    setSelectedBatch(batch);
                    setSelectedPlan(null);
                  }}
                  style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '10px' }}
                >
                  <div><strong>Time:</strong> {batch.displayTime}</div>
                  <div><strong>Days:</strong> {Object.values(batch.weekDetails).map(formatDay).join(', ')}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {selectedBatch && selectedBatch.batchPlansDto?.plans?.[0]?.payable_amount?.length > 0 && (
        <div style={{ marginTop: '1%' }}>
          <label>Select a Plan:</label>
          <div className="sport-cards-container">
            {selectedBatch.batchPlansDto.plans[0].payable_amount
            .filter(plan => plan.term_id !== 3)
              .map((plan, index) => {
                let termLabel = '';
                switch (plan.term_id) {
                  case 1:
                    termLabel = 'Monthly';
                    break;
                  case 2:
                    termLabel = 'Quarterly';
                    break;
                  case 4:
                    termLabel = 'Yearly';
                    break;
                  default:
                    termLabel = `Plan ${index + 1}`;
                }

                return (
                  <div
                    key={plan.id}
                    className={`sport-card ${selectedPlan?.id === plan.id ? 'selected' : ''}`}
                    onClick={() => setSelectedPlan(plan)}
                    style={{
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      padding: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    <div><strong>{termLabel} Plan</strong></div>
                    <div><strong>₹{plan.planFees}</strong></div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
{!showCouponSection && selectedAcademy && selectedSport && getUserId() && (
        <button
          className='otp-button'
          onClick={async () => {
            await handleFetchCoupons();
            setShowCouponSection(true);
          }}
          style={{ marginTop: '20px' }}
        >
          Apply Coupon
        </button>
      )}

      {showCouponSection && (
        <div className="coupon-section" style={{ marginTop: '20px' }}>
          <div className="floating-select-form" style={{ width: '98%' }}>
            <input
              type="text"
              name="manualCoupon"
              className={`walkin-form ${manualCouponCode ? "has-value" : ""}`}
              value={manualCouponCode}
              onChange={(e) => setManualCouponCode(e.target.value.toUpperCase())}
              placeholder="Enter Coupon Code"
            />
            {manualCouponCode && <label htmlFor="manualCoupon">Coupon Code</label>}
          </div>

          {couponOptions.length > 0 ? (
            <div>
              <label>Available Coupons:</label>
              <div className="sport-cards-container">
                {couponOptions.map((coupon) => (
                  <div
                    key={coupon.id}
                    className={`sport-card ${selectedCoupon?.id === coupon.id ? 'selected' : ''}`}
                    onClick={() => {
                      setSelectedCoupon(coupon);
                      setManualCouponCode(coupon.couponCode);
                    }}
                    style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '10px' }}
                  >
                    <div><strong>{coupon.title}</strong></div>
                    <div>{coupon.percentage}% off up to ₹{coupon.maxDiscountAmount}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ marginTop: '10px' }}>No coupons available.</div>
          )}

          <button style={{ marginTop: '10px' }} className='otp-button' onClick={handleApplyNow}>Apply Coupons</button>
        </div>
      )}

      {/* Joining Date */}
      <div className="floating-select-form" style={{ width: '98%', marginTop: '1%' }}>
      <input
  type="date"
  name="joiningDate"
  value={joiningDate}
  onChange={handleJoiningDateChange}
  className={`walkin-form ${joiningDate ? "has-value" : ""}`}
  onFocus={e => e.target.showPicker()}
  min={new Date().toISOString().split("T")[0]} 
/>

        <label htmlFor="joiningDate">Joining Date</label>
      </div>
      <div className="floating-select-form" style={{ width: '100%' }}>
        <Select
          options={[
            { value: 'Coach', label: 'Coach' },
            { value: 'Support Team', label: 'Support Team' },
            { value: 'Cbu', label: 'Cbu' },
            { value: 'Others', label: 'Others' },
          ]}
          value={discountGivenBy}
          onChange={setDiscountGivenBy}
          placeholder="Discount Given By (optional)"
          classNamePrefix="walkin-select"
          isClearable
          className={`walkin-form-dropdown ${discountGivenBy ? 'has-value' : ''}`}
          styles={{
            control: (provided) => ({
              ...provided,
              padding: '5px',
            }),
            placeholder: (provided) => ({
              ...provided,
              color: 'black',
            }),
          }}
        />
        {discountGivenBy && <label htmlFor="discountGivenBy">Discount Given By</label>}
      </div>
      {discountGivenBy && (
  <div className="floating-select-form" style={{ width: '98%' }}>
    <input
      type="text"
      className={`walkin-form ${discountedAmount ? 'has-value' : ''}`}
      placeholder="Enter Discounted Amount"
      value={discountedAmount}
      onChange={(e) => {
        const val = parseFloat(e.target.value);
        setDiscountedAmount(isNaN(val) ? 0 : val);
      }}
    />
    <label htmlFor="discountedAmount">Discounted Amount</label>
  </div>
)}

      <div className="floating-select-form" style={{ width: '98%' }}>
        <input
          type="text"
          className={`walkin-form ${discountComment ? 'has-value' : ''}`}
          placeholder="Any additional comments (optional)"
          value={discountComment}
          onChange={(e) => setDiscountComment(e.target.value)}
        />
        {discountComment && <label htmlFor="discountComment">Additional Comments</label>}
      </div>
      <button
        className="proceed-payment-btn"
        onClick={handleSubmit}
        disabled={!selectedPlan}
      >
        View Summary
      </button>


      {showSummaryPanel && (
        <div className="side-panel-overlay" onClick={() => setShowSummaryPanel(false)}>
          <div className="side-panel" onClick={(e) => e.stopPropagation()}>
            <div className="user-details-blue-box">
              <div className="side-panel-header">
                <h3 style={{ margin: '0px' }}>📝 Enrollment Summary</h3>
                <button className="close-button" onClick={() => setShowSummaryPanel(false)}>×</button>
              </div>

              <div className="summary-item"><strong>👤 Name:</strong> {getDisplayName()}</div>
              <div className="summary-item"><strong>📱 Mobile:</strong> +91 {mobileNumber}</div>
              <div className="summary-item"><strong>🏫 Academy:</strong> {selectedAcademy?.label}</div>
              <div className="summary-item"><strong>🏀 Sport:</strong> {selectedSport?.label}</div>
              <div className="summary-item"><strong>📂 Category:</strong> {selectedCategory}</div>
              <div className="summary-item"><strong>🎯 Player Level:</strong> {selectedLevel?.displayText}</div>
              <div className="summary-item"><strong>⏰ Batch Time:</strong> {selectedBatch?.displayTime}</div>
              <div className="summary-item"><strong>📅 Days:</strong> {Object.values(selectedBatch?.weekDetails || {}).map(formatDay).join(', ')}</div>
            {/* ---- PAYMENT FOR: first start → last end (mirror backend) ---- */}
{selectedPlanSummary && Array.isArray(selectedPlanSummary.break_up) && (() => {
  const paymentFor = selectedPlanSummary.break_up
    .filter(b => /^Payment for\b/i.test(b.label));

  if (!paymentFor.length) return null;

  const clean = (s) => s.replace(/^Payment for\s*:?\s*/i, '').trim();

  const splitRange = (label) => {
    const text = clean(label);
    const partsTo = text.split(/\s+to\s+/i);
    if (partsTo.length === 2) {
      return { start: partsTo[0].trim(), end: partsTo[1].trim() };
    }
    const partsDash = text.split(/\s*[–—-]\s*/);
    return { start: partsDash[0]?.trim() || '', end: partsDash.at(-1)?.trim() || '' };
  };

  const first = splitRange(paymentFor[0].label);
  const last  = splitRange(paymentFor[paymentFor.length - 1].label);

  const startText = first.start;
  const endText   = last.end || first.end || ''; 

  return (
    <div className="summary-item">
      <strong>🗓️ Payment for:</strong> {startText} to {endText}
    </div>
  );
})()}


              {selectedPlan?.discountAmount > 0 && (
                <div className="summary-item">
                  <strong>🎁 Coupon Discount:</strong> –₹{selectedPlan.discountAmount}
                </div>
              )}


              {discountGivenBy && discountedAmount > 0 && (
                <div className="summary-item">
                  <strong>💸 Discount by {discountGivenBy.label}:</strong> –₹{discountedAmount}
                </div>
              )}

              <div className="summary-item">
                <strong>📝 Registration Fee:</strong> ₹{selectedPlan?.joiningFees ?? 0}
              </div>

              <hr style={{ margin: '10px 0' }} />


              <div className="summary-item">
              <strong>💰 Total Payable: </strong> ₹{(selectedPlan?.amount ?? 0) + (selectedPlan?.joiningFees ?? 0)}<br />
                {selectedPlanSummary.break_up.map((b, i) => (
                  <div key={i} style={{ marginLeft: '1em' }}>
                    – {b.label} {b.value}
                  </div>
                ))}
                <hr />
              </div>






              <h4 style={{ margin: '0px' }}>🧾 Payment Mode:</h4>
              <div className="payment-options" style={{ marginTop: '10px' }}>
                {['Pay Now using RP QR', 'Cash'].map((method) => (
                  <label key={method} style={{ display: 'block', marginBottom: '5px' }}>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value={method}
                      checked={selectedPaymentMethod === method}
                      onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                    />{' '}
                    {method}
                  </label>
                ))}
                    {hasPrivilege(userData, 'PAYMENT', 'VENUE_QR') && (
    <label key="Venue QR" style={{ display: 'block', marginBottom: '5px' }}>
      <input
        type="radio"
        name="paymentMethod"
        value="Venue QR"
        checked={selectedPaymentMethod === 'Venue QR'}
        onChange={(e) => setSelectedPaymentMethod(e.target.value)}
      />{' '}
      Venue QR
    </label>
  )}
              </div>

              <button
                className="proceed-payment-btn"
                onClick={async () => {
                  if (selectedPaymentMethod === 'Pay Now using RP QR') {
                    await handleRPQRPayment();
                  } else if (selectedPaymentMethod === 'Cash') {
                    await handleCashPayment();
                  } else if (selectedPaymentMethod === 'Venue QR') {
                    await handleVenueQRPayment();
                  } else {
                    Swal.fire('Proceeding to Payment', `Method: ${selectedPaymentMethod}`, 'success');
                  }
                  setShowSummaryPanel(false);
                }}
                disabled={!selectedPaymentMethod}
              >
                Proceed to Payment
              </button>


            </div>
          </div>
        </div>
      )}




    </div>
  );
};

export default WalkInEnrollment;